import { Button } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

class MovingButtons extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    isLast: PropTypes.bool,
    isMovingMode: PropTypes.bool,
    isThisMoving: PropTypes.bool,
    disabled: PropTypes.bool,
    onMovingModeSwitch: PropTypes.func,
    onMoveStep: PropTypes.func,
  };

  onMovingModeEnable = () => {
    const { data } = this.props;
    this.props.onMovingModeSwitch(true, data.id);
  };

  onMovingModeDisable = () => {
    this.props.onMovingModeSwitch(false);
  };

  onMoveUp = () => {
    const { data } = this.props;
    this.props.onMoveStep(data.id, -1);
  };

  onMoveDown = () => {
    const { data } = this.props;
    this.props.onMoveStep(data.id, 1);
  };

  render() {
    const { data, isLast, isMovingMode, isThisMoving, disabled } = this.props;

    if (isMovingMode && !isThisMoving) {
      return null;
    }

    if (isMovingMode && isThisMoving) {
      return (
        <Button
          minimal
          disabled={disabled}
          text="Cancel moving"
          icon="cross"
          onClick={this.onMovingModeDisable}
          data-cy="button-report-cancel-moving-item"
        />
      );
    }

    return (
      <>
        <Button
          minimal
          disabled={disabled || (data.ordinal === 1 && isLast)}
          text="Move to..."
          icon="arrows-vertical"
          onClick={this.onMovingModeEnable}
          data-cy="button-report-move-item-to"
        />
        <Button
          minimal
          disabled={disabled || data.ordinal === 1}
          text="Up"
          icon="arrow-up"
          onClick={this.onMoveUp}
          data-cy="button-report-move-item-up"
        />
        <Button
          minimal
          disabled={disabled || isLast}
          text="Down"
          icon="arrow-down"
          onClick={this.onMoveDown}
          data-cy="button-report-move-item-down"
        />
      </>
    );
  }
}

export default MovingButtons;
